import {
  CONNECT_ACH_BANK_ACCOUNTS,
  CONNECT_ACH_BANK_ACCOUNTS_SUCCESS,
  CONNECT_ACH_BANK_ACCOUNTS_ERROR,
  FETCH_BANK_ACCOUNTS,
  FETCH_BANK_ACCOUNTS_SUCCESS,
  FETCH_BANK_ACCOUNTS_ERROR,
  CLEAR_BANK_ACCOUNTS_STATE,
} from './bankAccountActionConstants';

// connect bank account ACH
export const connectACHBankAccount = (payload) => ({
  type: CONNECT_ACH_BANK_ACCOUNTS,
  payload,
});

export const connectACHBankAccountSuccess = (payload) => ({
  type: CONNECT_ACH_BANK_ACCOUNTS_SUCCESS,
  payload,
});

export const connectACHBankAccountError = (payload) => ({
  type: CONNECT_ACH_BANK_ACCOUNTS_ERROR,
  payload,
});

// get bank accounts
export const fetchBankAccounts = (payload) => ({
  type: FETCH_BANK_ACCOUNTS,
  payload,
});

export const fetchBankAccountsSuccess = (payload) => ({
  type: FETCH_BANK_ACCOUNTS_SUCCESS,
  payload,
});

export const fetchBankAccountsError = (payload) => ({
  type: FETCH_BANK_ACCOUNTS_ERROR,
  payload,
});

export const clearBankAccount = (payload) => ({
  type: CLEAR_BANK_ACCOUNTS_STATE,
  payload,
});
